export default "__VITE_ASSET__36fcf0b4__"